// extracted by mini-css-extract-plugin
module.exports = {"gridCols":"Gear_gridCols__2SKAM","slotName":"Gear_slotName__EvCJT","selected":"Gear_selected__3hQTU"};